export { ReactComponent as Poll } from './svgs/poll.svg';
